export const profileSyncWorkExperienceItem = {
    templateUrl: Evisors.config.cdnRootWhitelabel + 'asset/partials/user/components/profileSyncWorkExperienceItem.html',
    bindings: {
        item: '<',
        hl: '<',
    },
};
